import { render, staticRenderFns } from "./option-aside.vue?vue&type=template&id=31f44230"
import script from "./option-aside.vue?vue&type=script&lang=js"
export * from "./option-aside.vue?vue&type=script&lang=js"
import style0 from "./option-aside.vue?vue&type=style&index=0&id=31f44230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports